import React from 'react';
import {useAppDispatch, useAppSelector} from "common/hook";
import {PeriodCalendar} from "../../../group-container/main-table/period-calendar/Period-calendar";
import {CustomPagination} from "components/pagination/CustomPagination";
import {fetchLessonsDemo} from "features/model/service/lessons/lessons-demo/fetchLessonsDemo";
import {LessonsItemDemo} from "./lessons-item-demo/LessonsItemDemo";

export const MainTableDemo = () => {
    const dispatch = useAppDispatch()
    const paginationData = useAppSelector((state) => state.lessonsDemo.pagination);
    const {page, pageSize, pageCount} = paginationData;

    const onChangeHandle = (event: React.ChangeEvent<unknown>, value: number) => {
        dispatch(fetchLessonsDemo({page: value -1}));
    };

    return (
        <>
            <PeriodCalendar create={true} print={false}/>
            <div className="data-tbl inner-group-lesson-tbl data-tbl-border data-tbl-padding">
                <div className="row thead">
                    <div className="col lesson-col">Занятие</div>
                    <div className="col status-col">Статус</div>
                    <div className="col lesson-time-col">Время занятия</div>
                    <div className="col btn-col"></div>
                </div>
                <LessonsItemDemo/>

                {pageCount > 1 && (
                    <CustomPagination pageCount={pageCount} onChangeHandle={onChangeHandle} />
                )}
            </div>
        </>
    );
};
